<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [config]="pageConfig"
  (onAdd)="onCreate()"
  (sortObject)="getSortItems($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (onShowHelpPage)="onShowHelpPage()"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
  [class]="isShowDetailPage ? 'd-none' : ''"
>
  <!--------------------------------------- value of purchase btns ---------------------------------------->
  <div class="card-toolbar" before-btns>
    <!-- userDomain -->
    <div class="tw-w-[300px] !tw-bg-transparent mt-2 mx-2 row tw-mb-[-4px]">
      <form-field
        [isLtr]="true"
        [(value)]="userDomain"
        [control]="form?.get('userDomain')"
        [label]="tableVocabs + 'resellerDomain'"
      >
      </form-field>
    </div>

    <!-- search btn -->
    <button
      (click)="onSearch()"
      class="btn btn-hover-rise btn-primary button-shadow tw-mx-1 txt-lg"
      type="button"
      mat-ripple
      [matTooltip]="'common.search' | translate"
    >
      <i class="mdi mdi-magnify mdi-20px tw-p-0 tw-text-white"></i>
    </button>
    
  </div>
  <!-------------------------------------- Table Content -------------------------------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-p-4">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- name -->
        <td>
          <td-value copyToClipboard [value]="item?.name"></td-value>
        </td>

        <!-- desktop -->
        <td>
          <span [desktop]="item?.desktop">
            {{ item?.desktop | enumToText : DesktopEnumValues }}</span
          >
        </td>

        <!-- identityDomain -->
        <td>
          <td-value
            class="font-vazir-ui"
            copyToClipboard
            [value]="item?.identityDomain"
          ></td-value>
        </td>

        <!-- userDomain -->
        <td>
          <app-expand-item
            *ngIf="item?.userDomain?.length > 1"
            [isCustom]="true"
            [placement]="'left'"
          >
            <ul class="custom dir-ltr tw-mb-0">
              <li *ngFor="let item of item?.userDomain" class="tw-mb-1">
                {{ item }}
              </li>
            </ul>
          </app-expand-item>

          <td-value
            *ngIf="item?.userDomain?.length < 2"
            copyToClipboard
            [value]="item?.userDomain[0]"
          >
          </td-value>
        </td>

        <!-- created -->
        <td>
          <td-value type="dateTime" [value]="item?.created"></td-value>
        </td>

        <!-------------------------------------- operations -------------------------------------->

        <td class="sticky-td">
          <div
            app-menu-btn
            [matMenuTriggerFor]="menu"
            [isShowDotsMenu]="true"
          ></div>

          <mat-menu #menu="matMenu" xPosition="before">
            <!-- edit button -->
            <div app-menu-btn icon="edit" (click)="onUpdate(item.id)"></div>

            <!-- detail button -->
            <div
              app-menu-btn
              icon="mdi mdi-text-box-search-outline mdi-20px"
              color="gray"
              [title]="'common.detail'"
              (click)="onDetail(item.id)"
            ></div>

            <!-- delete button -->
            <div
              app-menu-btn
              icon="delete"
              (click)="onDelete(item.id, item.name)"
            ></div>
          </mat-menu>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!-- form -->
<ng-container *ngIf="pageConfig?.isVisibleForm">
  <app-customer-domain-form
    page-form
    [LoginPageModesEnum]="LoginPageModesEnumValues"
    [formPageConfig]="formPageConfig"
    (closeFormPage)="getFormResponse($event)"
  >
  </app-customer-domain-form>
</ng-container>

<!-------------------------------------- Detail -------------------------------------->

<ng-container *ngIf="isShowDetailPage">
  <app-domain-details
    (closePage)="onHideDetail()"
    [model]="formDetailPageConfig"
  >
  </app-domain-details>
</ng-container>
<!-------------------------------------- Audit -------------------------------------->
<ng-container *ngIf="pageConfig?.isVisibleAuditPage">
  <app-audit
    [service]="currentService"
    [methodName]="auditApiMethodName"
    (hidePage)="onHideAuditPage()"
  >
  </app-audit>
</ng-container>

<!-------------------------------------- help -------------------------------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="pageName"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
